// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectQueryResult, selectIpmsComponentsPageLoading, selectIpmsComponentsShowInitWaitingMessage} from '../_selectors/ipms-component.selectors';

export class IpmsComponentsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectIpmsComponentsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectIpmsComponentsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
